Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Counter1304525540",
  {"root":"Counter1304525540--root","btn":"Counter1304525540--btn","DefaultColor":"color-5","DefaultDisabledColor":"color-3","DefaultErrorColor":"#f64d43","DefaultBackgroundColor":"color-1","DefaultWidth":"96px","MainColor":"--overridable","DisabledColor":"--overridable","MainWidth":"--overridable","counterColor":"\"color(fallback(--overridable, color-5))\"","counterDisabledColor":"\"color(fallback(--overridable, color-3))\"","counterWidth":"\"fallback(--overridable, 96px)\""},
  "",
  2,
  "Counter1304525540"
);

